import axios from 'axios';
import { getAuthToken, getPortalType } from '@/utils/auth';
import { apiUrl } from './config';

/**
 * Get authentication headers
 */
const getAuthHeaders = () => {
  const portal = getPortalType(window.location.pathname || '');
  const token = getAuthToken(portal);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * User Preferences API
 */
export const preferencesAPI = {
  /**
   * Get user preferences
   * @returns {Promise} User preferences data
   */
  getPreferences: async () => {
    try {
      const response = await axios.get(
        apiUrl('users/preferences/'),
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching preferences:', error);
      throw error;
    }
  },

  /**
   * Update user preferences
   * @param {Object} preferences - Preferences data to update
   * @returns {Promise} Updated preferences data
   */
  updatePreferences: async (preferences) => {
    try {
      const response = await axios.patch(
        apiUrl('users/preferences/'),
        preferences,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating preferences:', error);
      throw error;
    }
  },
};

